<div class="container">
  <mat-card style="margin-top: 50px">
    <mat-card-content style="margin-left: auto; margin-right: auto">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-10">
          <h1 class="mt-5">Login</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <form class="standard-form">
            <mat-form-field>
              <mat-label>Email</mat-label>
              <input
                matInput
                name="emailAddress"
                [(ngModel)]="emailAddress"
                type="email"
                (keydown)="onKeyDown($event)"
              /> </mat-form-field
            ><br />
            <ng-container *ngIf="!forgotPasswordFlag">
              <mat-form-field>
                <mat-label>Password</mat-label>
                <input
                  matInput
                  name="password"
                  type="password"
                  [(ngModel)]="password"
                  (keydown)="onKeyDown($event)"
                />
              </mat-form-field>
            </ng-container>
          </form>
        </div>
        <div class="col-md-2"></div>
      </div>
      <div class="row" *ngIf="loggingIn">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <ng-container>
            <i class="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;Logging In, Please Wait...
          </ng-container>
        </div>
        <div class="col-md-2"></div>
      </div>
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <span style="color: red">{{ errorMessage }}</span>
        </div>
        <div class="col-md-2"></div>
      </div>
      <div class="row" *ngIf="resendFlag">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <button
            mat-raised-button
            class="piButton"
            (click)="resendEmailVerification()"
          >
            Resend Email Verification
          </button>
        </div>
        <div class="col-md-2"></div>
      </div>
      <div class="row">
        <div class="col-md-6"></div>
        <div class="col-md-4">
          <table>
            <tr *ngIf="!forgotPasswordFlag">
              <td>
                <button
                  mat-raised-button
                  class="piButton"
                  (click)="loginUser()"
                >
                  Login
                </button>
              </td>
              <td>
                <button
                  mat-raised-button
                  class="piButton"
                  (click)="forgotPassword()"
                >
                  Forgot Password?
                </button>
              </td>
            </tr>
            <tr *ngIf="forgotPasswordFlag">
              <td>
                <button
                  mat-raised-button
                  class="piButton"
                  (click)="sendResetPassword()"
                >
                  Send Reset Email
                </button>
              </td>
              <td>
                <button
                  mat-raised-button
                  class="piButton"
                  (click)="cancelResetPassword()"
                >
                  Cancel
                </button>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-md-2"></div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
